import types from "./types.js";
// import { CALL_API } from "@cdkglobal/react-core-reduxapi";
import config from "../config/app.conf.json";
import axios from "axios";

export const actions = {
    setScreen: (screen) => {
        return dispatch => {
            dispatch({
                type: types.SET_SCREEN,
                payload: screen,
            })
        }
    },
    getBundleList: ({ accessToken }) => {
        return dispatch => {
            dispatch({
                type: types.GET_BUNDLE_LIST_REQUEST
            });
            axios.get(`${config.api.api_gateway_url}/v2/admin/bundles`, {
                headers: {
                    Authorization: "Bearer " + accessToken,
                    Accept: "application/json"
                }
            }).then(res => {
                dispatch({ type: types.GET_BUNDLE_LIST_RECEIVE, payload: {...res.data} })
            }).catch(error => {
                if(error.response && error.response?.data) {
                    dispatch({ type: types.GET_BUNDLE_LIST_ERROR, payload: error.response.data });
                } else {
                    dispatch({ type: types.GET_BUNDLE_LIST_ERROR, payload: {} })
                }
            })
        }
    },
    getApiList: ({ accessToken }) => {
        return dispatch => {
            dispatch({
                type: types.GET_API_LIST_REQUEST
            });
            axios.get(`${config.api.api_gateway_url}/v1/admin/bundle-apis`, {
                headers: {
                    Authorization: "Bearer " + accessToken,
                    Accept: "application/json"
                }
            }).then(res => {
                dispatch({ type: types.GET_API_LIST_RECEIVE, payload: {...res.data} })
            }).catch(error => {
                if(error.response && error.response?.data) {
                    dispatch({ type: types.GET_API_LIST_ERROR, payload: error.response.data });
                } else {
                    dispatch({ type: types.GET_API_LIST_ERROR, payload: {} })
                }
            })
        }
    },
    createBundle: ({ accessToken, bundleData }) => {
        return dispatch => {
            dispatch({
                type: types.CREATE_BUNDLE_POST_REQUEST
            });
            axios.post(`${config.api.api_gateway_url}/v2/admin/bundles`, bundleData, {
                headers: {
                    Authorization: "Bearer " + accessToken,
                    Accept: "application/json"
                }
            }).then(res => {
                dispatch({ type: types.CREATE_BUNDLE_POST_RECEIVE, payload: {...res.data} })
            }).catch(error => {
                if(error.response && error.response?.data) {
                    dispatch({ type: types.CREATE_BUNDLE_POST_ERROR, payload: error.response.data });
                } else {
                    dispatch({ type: types.CREATE_BUNDLE_POST_ERROR, payload: {} })
                }
            })
        }
    },
    updateBundle: ({ accessToken, bundleData }) => {
        return dispatch => {
            dispatch({
                type: types.UPDATE_BUNDLE_PUT_REQUEST
            });
            axios.put(`${config.api.api_gateway_url}/v2/admin/bundles`, bundleData, {
                headers: {
                    Authorization: "Bearer " + accessToken,
                    Accept: "application/json"
                }
            }).then(res => {
                dispatch({ type: types.UPDATE_BUNDLE_PUT_RECEIVE, payload: {...res.data} })
            }).catch(error => {
                if(error.response && error.response?.data) {
                    dispatch({ type: types.UPDATE_BUNDLE_PUT_ERROR, payload: error.response.data });
                } else {
                    dispatch({ type: types.UPDATE_BUNDLE_PUT_ERROR, payload: {} })
                }
            })
        }
    },
    clearBundleUpdateErrors: () => {
        return dispatch => {
            dispatch({
                type: types.CLEAR_BUNDLE_UPDATE_ERRORS,
            })
        }
    },
    getBundlePricingPlans: ({ accessToken, bundleId }) => {
        return dispatch => {
            dispatch({
                type: types.GET_BUNDLE_PRICE_PLANS_REQUEST
            });
            axios.get(`${config.api.api_gateway_url}/v1/admin/bundle/${bundleId}/price-plans?view=summary`, {
                headers: {
                    Authorization: "Bearer " + accessToken,
                    Accept: "application/json"
                }
            }).then(res => {
                dispatch({ type: types.GET_BUNDLE_PRICE_PLANS_RECEIVE, payload: {...res.data} })
            }).catch(error => {
                if(error.response && error.response?.data) {
                    dispatch({ type: types.GET_BUNDLE_PRICE_PLANS_ERROR, payload: error.response.data });
                } else {
                    dispatch({ type: types.GET_BUNDLE_PRICE_PLANS_ERROR, payload: {} })
                }
            })
        }
    },
    resetBundlePricingPlans: () => {
        return dispatch => {
            dispatch({
                type: types.RESET_BUNDLE_PRICE_PLANS,
            })
        }
    },
    resetSelectedPricingPlan: () => {
        return dispatch => {
            dispatch({
                type: types.RESET_SELECTED_PRICING_PLAN,
            })
        }
    },
    resetBundlePlanDetails: () => {
        return dispatch => {
            dispatch({
                type: types.RESET_BUNDLE_PLAN_DETAILS,
                })
        }
    },
    resetBundlePlan: () => {
        return dispatch => {
            dispatch({
                type: types.RESET_BUNDLE_PLAN,
            })
        }
    },
    createBundlePricePlan: ({ accessToken, bundleId, pricePlanData }) => {
        return dispatch => {
            dispatch({
                type: types.CREATE_BUNDLE_PRICE_PLAN_REQUEST
            });
            axios.post(`${config.api.api_gateway_url}/v1/admin/bundle/${bundleId}/price-plan`, pricePlanData, {
                headers: {
                    Authorization: "Bearer " + accessToken,
                    Accept: "application/json"
                }
            }).then(res => {
                dispatch({ type: types.CREATE_BUNDLE_PRICE_PLAN_RECEIVE, payload: {...res.data} })
            }).catch(error => {
                if(error.response && error.response?.data) {
                    dispatch({ type: types.CREATE_BUNDLE_PRICE_PLAN_ERROR, payload: error.response.data });
                } else {
                    dispatch({ type: types.CREATE_BUNDLE_PRICE_PLAN_ERROR, payload: {} })
                }
            })
        }
    },
    updateBundlePricePlan: ({ accessToken, bundleId, pricePlanId, pricePlanData, groupId, planType }) => {
        return dispatch => {
            dispatch({
                type: types.UPDATE_BUNDLE_PRICE_PLAN_REQUEST
            });
            const targetId = planType === 'advanced' && groupId ? groupId : pricePlanId;
            axios.put(`${config.api.api_gateway_url}/v1/admin/bundles/${bundleId}/price-plans/${targetId}`, pricePlanData, {
                headers: {
                    Authorization: "Bearer " + accessToken,
                    Accept: "application/json"
                }
            }).then(res => {
                dispatch({ type: types.UPDATE_BUNDLE_PRICE_PLAN_RECEIVE, payload: {...pricePlanData} })
            }).catch(error => {
                if(error.response && error.response?.data) {
                    dispatch({ type: types.UPDATE_BUNDLE_PRICE_PLAN_ERROR, payload: error.response.data });
                } else {
                    dispatch({ type: types.UPDATE_BUNDLE_PRICE_PLAN_ERROR, payload: {} })
                }
            })
        }
    },
    fetchPlanDetails: ({ accessToken, bundleId, pricePlanId, groupId, planType }) => {
        return dispatch => {
            dispatch({
                type: types.FETCH_PLAN_DETAILS_REQUEST
            });

            let url = `${config.api.api_gateway_url}/v1/admin/bundle/${bundleId}/price-plans/${pricePlanId}`;
            if (planType === 'advanced' && groupId) {
                url = `${config.api.api_gateway_url}/v1/admin/bundle/${bundleId}/price-plans?groupId=${groupId}`;
            }

            axios.get(url, {
                headers: {
                    Authorization: "Bearer " + accessToken,
                    Accept: "application/json"
                }
            }).then(res => {
                let planDetails = res.data;
                if (Array.isArray(res.data) && planType === 'advanced') {
                    const basePlan = res.data[0] || {};
                    const basePlanName = basePlan.groupName || basePlan.planName?.replace(/ - (basic|plus|pro|Custom)$/i, '') || '';

                    const tiers = {};
                    res.data.forEach(p => {
                        let tierKey = 'custom';
                        if (p.planName?.toLowerCase().endsWith('basic')) tierKey = 'basic';
                        else if (p.planName?.toLowerCase().endsWith('plus')) tierKey = 'plus';
                        else if (p.planName?.toLowerCase().endsWith('pro')) tierKey = 'pro';

                        let displayTitle = p.planName;
                        if (tierKey === 'basic') displayTitle = 'Basic';
                        else if (tierKey === 'plus') displayTitle = 'Plus';
                        else if (tierKey === 'pro') displayTitle = 'Pro';

                        tiers[tierKey] = {
                            priceId: p.id, // Include priceId for update API calls
                            title: displayTitle,
                            basePrice: p.price,
                            description: p.description || "",
                            containers: (p.containers || []).map(c => ({
                                id: c.containerId,
                                containerId: c.containerId,
                                name: c.name,
                                description: c.description,
                                quotaLimit: c.quota,
                                overages: c.overage,
                                endpoints: (c.endpoints || []).map(ep => ({ ...ep, id: ep.endpointId })),
                                channels: (c.channels || []).map(ch => ({ ...ch, id: ch.channelId })),
                            })),
                            isActive: p.status === 'active'
                        };
                    });

                    planDetails = {
                        ...basePlan,
                        planName: basePlanName,
                        tiers: tiers
                    };
                }
                dispatch({ type: types.FETCH_PLAN_DETAILS_RECEIVE, payload: planDetails })
            }).catch(error => {
                if(error.response && error.response?.data) {
                    dispatch({ type: types.FETCH_PLAN_DETAILS_ERROR, payload: error.response.data });
                } else {
                    dispatch({ type: types.FETCH_PLAN_DETAILS_ERROR, payload: {} })
                }
            })
        }
    },
    clearFetchPlanDetailsError: () => {
        return dispatch => {
            dispatch({
                type: types.CLEAR_FETCH_PLAN_DETAILS_ERROR,
            })
        }
    },
    loadSubPlansFromDetails: (subPlans) => {
        return dispatch => {
            dispatch({
                type: types.LOAD_SUB_PLANS_FROM_DETAILS,
                payload: subPlans,
            })
        }
    },
    clearAddEditPricePlanError: () => {
        return dispatch => {
            dispatch({
                type: types.CLEAR_ADD_EDIT_PRICE_PLAN_ERROR,
            })
        }
    },
    setSelectedPricingPlan: (pricePlan) => {
        return dispatch => {
            dispatch({
                type: types.SET_SELECTED_PRICING_PLAN,
                payload: pricePlan,
            })
        }
    },
    setPricePlanForHistory: (pricePlan) => {
        return dispatch => {
            dispatch({
                type: types.SET_PRICE_PLAN_FOR_HISTORY,
                payload: pricePlan,
            })
        }
    },
    setPrevScreenForHistory: (screen) => {
        return dispatch => {
            dispatch({
                type: types.SET_PREV_SCREEN_FOR_HISTORY,
                payload: screen,
            })
        }
     },
    clearPricePlanForHistory: () => {
        return dispatch => {
            dispatch({
                type: types.CLEAR_PRICE_PLAN_HISTORY,
            })
        }
    },
    setBundlePlanDetails: ({ field, value }) => {
        return dispatch => {
            dispatch({
                type: types[`HANDLE_${field}_CHANGE`],
                payload: value,
            })
        }
    },
    setBundleCreateError: () => {
        return dispatch => {
            dispatch({
                type: types.SET_CREATE_BUNDLE_ERROR,
            })
        }
    },
    removeToast1: () => {
        return dispatch => {
            dispatch({
                type: types.REMOVE_TOAST1,
            })
        }
    },
    setSelectedBundle: (bundle) => {
        return dispatch => {
            dispatch({
                type: types.SET_SELECTED_BUNDLE,
                payload: bundle,
            })
        }
    },
    setSubPlan: (subPlan) => {
        return dispatch => {
            dispatch({
                type: types.SET_SUB_PLAN,
                payload: subPlan,
            })
        }
    },
    clearSubPlan: () => {
        return dispatch => {
            dispatch({
                type: types.CLEAR_SUB_PLAN,
                payload: null,
            })
        }
    },
    createSubPlanContainer: (containers) => {
        return dispatch => {
            dispatch({
                type: types.CREATE_SUB_PLAN_CONTAINER,
                payload: containers,
            })
        }
    },
    setSubPlanContainer: ({id, name, description, quotaLimit, overages, apiEndpoints, channels}) => {
        return dispatch => {
            dispatch({
                type: types.SET_SUB_PLAN_CONTAINER,
                payload: { id, name, description, quotaLimit, overages, apiEndpoints, channels },
            })
        }
    },
    setSelectedSubPlanContainer: (containerName) => {
        return dispatch => {
            dispatch({
                type: types.SET_SELECTED_SUB_PLAN_CONTAINER,
                payload: containerName,
            })
        }
    },
    clearSubPlanContainer: () => {
        return dispatch => {
            dispatch({
                type: types.CLEAR_SUB_PLAN_CONTAINER,
                payload: {},
            })
        }
    },
    removeSubPlanContainer: (name) => {
        return dispatch => {
            dispatch({
                type: types.REMOVE_SUB_PLAN_CONTAINER,
                payload: { name },
            })
        }
    },
    getBundleApiEndpoints: ({ accessToken, bundleId }) => {
        return dispatch => {
            dispatch({
                type: types.GET_BUNDLE_API_ENDPOINTS_REQUEST
            });
            axios.get(`${config.api.api_gateway_url}/v1/admin/bundles/${bundleId}/components`, {
                headers: {
                    Authorization: "Bearer " + accessToken,
                    Accept: "application/json"
                }
            }).then(res => {
                dispatch({ type: types.GET_BUNDLE_API_ENDPOINTS_RECEIVE, payload: {...res.data}, bundleId })
            }).catch(error => {
                if(error.response && error.response?.data) {
                    dispatch({ type: types.GET_BUNDLE_API_ENDPOINTS_ERROR, payload: error.response.data });
                } else {
                    dispatch({ type: types.GET_BUNDLE_API_ENDPOINTS_ERROR, payload: {} })
                }
            })
        }
    },
    setSubPlanDetails: ({ field, value }) => {
        return dispatch => {
            dispatch({
                type: types[`HANDLE_SUB_PLAN_${field}_CHANGE`],
                payload: value,
            })
        }
    },
    setDraftSubPlanState: (draftState) => {
        return dispatch => {
            dispatch({
                type: types.SET_DRAFT_SUB_PLAN_STATE,
                payload: draftState,
            })
        }
    },
    clearDraftSubPlanState: () => {
        return dispatch => {
            dispatch({
                type: types.CLEAR_DRAFT_SUB_PLAN_STATE,
            })
        }
    },
}